import { useFilterConfig } from '../hooks/useFilterConfig';
import { CountryFilter } from './reusableFilters/CountryFilter';
import { LanguageFilter } from './reusableFilters/LanguageFilter';
import { SelectFilter } from './reusableFilters/SelectFilter';
import { SupportedListingsFilter } from './singleUseFilters/SupportedListingsFilter';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function SolutionsPartnerFilterControls() {
  const {
    PROFILE_ACCREDITATIONS,
    PROFILE_BUDGET,
    PROFILE_CERTIFICATIONS,
    PROFILE_LANGUAGES,
    PROFILE_LOCATION_COUNTRY,
    PROFILE_OFFICE_LOCATION,
    PROFILE_SOLUTIONS_PARTNER_TIER
  } = useFilterConfig();
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(SelectFilter, {
      filter: PROFILE_ACCREDITATIONS
    }), /*#__PURE__*/_jsx(SelectFilter, {
      filter: PROFILE_OFFICE_LOCATION
    }), /*#__PURE__*/_jsx(CountryFilter, {
      filter: PROFILE_LOCATION_COUNTRY
    }), /*#__PURE__*/_jsx(LanguageFilter, {
      filter: PROFILE_LANGUAGES
    }), /*#__PURE__*/_jsx(SelectFilter, {
      filter: PROFILE_BUDGET
    }), /*#__PURE__*/_jsx(SupportedListingsFilter, {}), /*#__PURE__*/_jsx(SelectFilter, {
      filter: PROFILE_CERTIFICATIONS
    }), /*#__PURE__*/_jsx(SelectFilter, {
      filter: PROFILE_SOLUTIONS_PARTNER_TIER
    })]
  });
}